<template>
  <div class="task-manage-nav">
    <div class="nav">
        <div style="display:inline-block">
            <img style="width:30px;margin:0 5px 0 24px" src="../assets/img/nav-icon.png" alt="">
            <img style="width:83px;margin-top:7px;" src="../assets/img/nav-logo.png" alt="">
        </div>
        <div @click="selectNav('MyTask')" :class="{'active':currentNav=='MyTask'}" class="list" style="margin-left:80px">
            <router-link to="/UserNav/MyTask">
                <a-icon type="snippets" /> 
                <span>我的任务</span>
            </router-link>
        </div>
        <div @click="selectNav('UserProjectSquare')" :class="{'active':currentNav=='UserProjectSquare'}" class="list">
            <router-link to="/UserNav/UserProjectSquare">
                <a-icon type="project" />
                <span>项目广场</span>
            </router-link>
        </div>
        <div @click="selectNav('UserRevenueList')" :class="{'active':currentNav=='UserRevenueList'}" class="list">
            <router-link to="/UserNav/UserRevenueList">
                <a-icon type="account-book" />
                <span>收入列表</span>
            </router-link>
        </div>
        <Logout></Logout>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Logout from './Logout';
export default {
    name: 'AdminNav',
    props: {
        msg: String
    },
    data() {
        return {
            currentNav: 'MyTask',
        }
    },
    components: {
        Logout,
    },
    methods: {
        selectNav(type) {
            this.currentNav = type
        },
        success(msg) {
            this.$message.success(msg);
        },
        error(msg) {
            this.$message.error(msg);
        },
        warning(msg) {
            this.$message.warning(msg);
        },
    },
    mounted: function() {

    }
}
</script>

<style scoped lang="less">
    .task-manage-nav{
        height: 100%;
        display: flex;
        flex-direction: column;
        .nav{
            height: 48px;
            background: rgba(13, 23, 37, 1);
            div.list{
                display:inline-block;
                color: #fff;
                font-size: 14px;
                line-height: 48px;
                height: 48px;
                cursor: pointer;
                a{
                    color: #fff;
                    width: 100%;
                    height: 100%;
                    display: inline-block;
                    padding: 0 24px;
                }
                span{
                    margin-left:5px;
                }
            }
            div.active{
                border-bottom: 3px solid rgba(24, 144, 255, 1);
                color: rgba(24, 144, 255, 1);
                background: rgba(24, 144, 255, 0.1);
                a{
                    color: rgba(24, 144, 255, 1);
                }
            }
        }
    }
</style>
